export const personalInfo = {
  name: 'Manish Khatiwada',
  initials: 'MK',
  title: 'Senior Quality Assurance Engineer',
  greeting: '👋 Hello, I\'m',
  description: 'Passionate about delivering flawless digital experiences through comprehensive testing strategies. Specializing in test automation, API testing, and leading QA teams to ensure product excellence.',
  contact: {
    email: 'iamkmanish12@gmail.com',
    phone: '+977 984-271-4801',
    linkedin: 'https://www.linkedin.com/in/enzomanish',
    github: 'https://github.com/manish-kh'
  },
  location: 'Kathmandu, Nepal'
};

export const stats = [
  { number: '5+', label: 'Years Experience' },
  { number: '120+', label: 'Projects Completed' },
  { number: '98%', label: 'Bug Detection Rate' },
  { number: '50+', label: 'Automation Scripts' }
];

export const expertise = [
  {
    icon: '🔍',
    title: 'Manual Testing',
    skills: [
      'Functional Testing',
      'Regression Testing',
      'UAT Testing',
      'Risk-Based Testing',
      'Cross-browser Testing'
    ]
  },
  {
    icon: '⚙️',
    title: 'Automation Testing',
    skills: [
      'UI Automation (Cypress || Playwright)',
      'API Automation (Postman)',
      'Mobile Automation (Appium)',
      'Selenium with Python',
      'CI/CD Integration'
    ]
  },
  {
    icon: '📱',
    title: 'Mobile Testing',
    skills: [
      'Android Testing',
      'iOS Testing',
      'Appium Framework',
      'Device Farm Testing',
      'Mobile UI/UX Validation'
    ]
  },
  {
    icon: '🔌',
    title: 'API Testing',
    skills: [
      'REST API Testing',
      'Postman Automation',
      'API Documentation',
      'Performance Testing',
      'Integration Testing'
    ]
  },
  {
    icon: '🗄️',
    title: 'Database Testing',
    skills: [
      'SQL (CRUD, Joins)',
      'EdgeDB Operations',
      'PostgreSQL Validation',
      'MySQL Testing',
      'Data Integrity Checks'
    ]
  },
  {
    icon: '👥',
    title: 'Team Leadership',
    skills: [
      'QA Team Building',
      'Scrum Master',
      'Mentorship',
      'Agile/Scrum/Kanban',
      'Stakeholder Reporting'
    ]
  }
];

export const experience = [
  {
    date: 'April 2023 - Present',
    title: 'Senior Quality Assurance Engineer',
    company: 'Baneshwor, Kathmandu',
    description: 'Leading QA initiatives and team building efforts while implementing comprehensive automation frameworks. Driving quality culture through mentorship and establishing best practices for testing workflows.'
  },
  {
    date: 'April 2022 - April 2023',
    title: 'Quality Assurance Consultant',
    company: 'Squadcast (via Code Himalaya)',
    description: 'Architected test automation frameworks following industry best practices. Conducted comprehensive testing strategies including automated, exploratory, and performance testing within CI/CD pipelines.'
  },
  {
    date: 'April 2021 - April 2023',
    title: 'Quality Assurance Engineer',
    company: 'Code Himalaya, Lalitpur',
    description: 'Developed and executed comprehensive test strategies for web and mobile applications. Established automation frameworks using Cypress and Selenium, significantly reducing testing time.'
  },
  {
    date: 'November 2017 - May 2018',
    title: 'Junior PHP Frontend Developer',
    company: 'Spark Tech Pvt Ltd',
    description: 'Joined as a compulsory 8th semester intern, gaining exposure to office culture and workflows while building efficient PHP modules, optimizing database structures, and developing a foundational understanding of the software development lifecycle and quality assurance practices.'
  }
];

export const skills = {
  'Automation Tools': ['Cypress', 'Postman', 'Selenium', 'Appium', 'Python', 'Playwright'],
  'CI/CD & DevOps': ['Jenkins', 'GitLab CI/CD', 'Git', 'GitHub Actions', 'Docker', 'Kubernetes'],
  'Databases': ['SQL', 'EdgeDB', 'PostgreSQL', 'MySQL', 'MongoDB'],
  'Programming': ['Python', 'JavaScript', 'TypeScript', 'Bash'],
  'Methodologies': ['Agile', 'Scrum', 'Kanban', 'TDD', 'BDD'],
  'Tools & Platforms': ['Jira', 'Confluence', 'Figma', 'Slack', 'VS Code']
};

export const contactMethods = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
      </svg>
    ),
    title: 'Email',
    value: 'iamkmanish12@gmail.com',
    link: 'mailto:iamkmanish12@gmail.com'
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 006 3.75v16.5a2.25 2.25 0 002.25 2.25h7.5A2.25 2.25 0 0018 20.25V3.75a2.25 2.25 0 00-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
      </svg>
    ),
    title: 'Phone',
    value: '+977 984-271-4801',
    link: 'tel:+9779842714801'
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
      </svg>
    ),
    title: 'LinkedIn',
    value: 'Connect with me',
    link: 'https://www.linkedin.com/in/enzomanish'
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
      </svg>
    ),
    title: 'GitHub',
    value: 'View Projects',
    link: 'https://github.com/manish-kh'
  }
];
